export enum ReportsRouteTypeEnum {
    report,
    reportSharedReports,
    reportsHype
}

/**
 * URL Paths for Reports and its sections
 */
export const reportsRouteUrlPaths = {
    baseUrl: 'Report',
    [ReportsRouteTypeEnum.report]: ['reports', 'report'],
    [ReportsRouteTypeEnum.reportSharedReports]: ['reports', 'shared'],
    [ReportsRouteTypeEnum.reportsHype]: ['reports']
};

/**
 * Breaks the URL into known pieces so the current location can be evaluated
 * Should be kept in sync with paths in {@link reportsRouteUrlPaths}
 */
// eslint-disable-next-line max-len
export const reportsUrlParse: RegExp = /Report\/?(reports)?\/?(report|shared)?\/?(\d+)?/;
